import { useMemo } from 'react';

import { useInstantSearch } from 'react-instantsearch';

import { useI18n } from '@change-corgi/core/react/i18n';

type Result = ModelHookResult<{
	countLocalized: string;
	query: string | undefined;
	count: number;
	isLoading: boolean;
}>;

export function useSearchQueryResultText(): Result {
	const { results, indexUiState, status } = useInstantSearch();
	const { localizeNumber } = useI18n();

	// The `__isArtificial` flag makes sure not to display the No Results message
	// when no hits have been returned.
	const isLoading = useMemo(
		() => (!!results.__isArtificial || status === 'loading' || status === 'stalled') && status !== 'error',
		[results, status],
	);

	return {
		data: {
			isLoading,
			countLocalized: useMemo(() => localizeNumber(results.nbHits), [results.nbHits, localizeNumber]),
			query: indexUiState.query,
			count: results.nbHits,
		},
	};
}
